import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import moment from 'moment';
import { BACKEND_URL } from '../config/constants';

const PdfRadiologia = React.memo(({ title, list, theme }) => {
  const componentRef = useRef();
  const textIcon = (theme === 'dark' ? '_dark' : '');

  const handlePrint = useReactToPrint({
    documentTitle: 'Relatório Monitoramento Radiologia',
    content: () => componentRef.current,
  });

  return (
    <>
      <button className={'buttonIcon ' + theme} onClick={handlePrint}><img src={"/img/icon_printer" + textIcon + ".svg"} alt="" /></button>
      <div style={{ display: 'none' }}>
        <div ref={componentRef} style={{ width: '100%', height: window.innerHeight }}>
          <div className='inforow' style={{ marginTop: '40px', marginLeft: '80px', marginRight: '80px' }}>
            <div className="inforow right">
              <h3 style={{ fontSize: '20px' }}>{title}</h3 >
            </div>
            <div className="inforow left">
              <img src="/img/logo_powered_insightcare.png" alt="Insightcare" style={{ width: '12vw', position: 'relative', marginLeft: '32px', float: 'right' }} />
              {
                BACKEND_URL.includes('gruposanta') ? (
                  <img src="/img/logo_gruposanta.png" alt="Gruposanta" style={{ width: '12vw', position: 'relative', float: 'right', marginLeft: '25px' }} />
                ) : null
              }
            </div>
          </div>
          <div className="inforow" style={{ marginLeft: '80px', marginRight: '80px' }}>
            <div className='inforow right'>
              <div className='infoText' style={{ fontSize: '12px' }}>Mostrando {list.length} pacientes </div>
            </div>
            <div className='inforow left'>
              <div className='infoText' style={{ fontSize: '12px' }}>Impresso em {moment().format('HH:mm, [dia] D [de] MMMM [de] YYYY')}</div>
            </div>
          </div>
          <div className='tablePDF'>
            <table>
              <thead>
                <tr>
                  <th>Status</th>
                  <th>Leito</th>
                  <th>Paciente</th>
                  <th>Exame</th>
                  <th>Imagem</th>
                  <th>Tempo</th>
                </tr>
              </thead>
              <tbody>
                {list.map((data, index) => {
                  // let key = data.CODIGOITEMPEDIDO + data.CODIGOATENDIMENTO;
                  const key = `PDF:${index}`;
                  let status = "-";
                  let color = '';
                  let statusClass = "ready";
                  let tdClassRx = "";
                  let spanClassRx = "";
                  let tdClassFarm = "";
                  let spanClassFarm = "";
                  let name = data.NOMEPACIENTE.split(' ')[0] + ' ' + data.NOMEPACIENTE.split(' ').slice(-1).join(' ');
                  if (data.TIPOATENDIMENTO === 'U') {
                    color = 'red';
                  }
                  if (data.IMAGEMREALIZADA) {
                    status = "Aguardando laudo";
                    tdClassRx = "attention";
                    spanClassRx = "success-circle";
                    statusClass = "ready";
                  } else {
                    status = "Aguardando imagem";
                    statusClass = "waiting";
                  }

                  if (data.MINUTOSAGUARDANDO > 120) {
                    tdClassFarm = "attention";
                    spanClassFarm = "attention-circle";
                  } else {
                    spanClassFarm = "success-circle";
                  }

                  let time = data.MINUTOSAGUARDANDO;
                  if (data.MINUTOSAGUARDANDO > 60) {
                    if (data.MINUTOSAGUARDANDO > 1440) {
                      var days = (data.MINUTOSAGUARDANDO / 1440);
                      var rdays = Math.floor(days);
                      var hours = (days - rdays) * 24;
                      var rhours = Math.floor(hours);
                      var minutes = (hours - rhours) * 60;
                      var rminutes = Math.round(minutes);
                      time = rdays + " d " + rhours + " h " + rminutes + " m";
                    } else {
                      var hours = (data.MINUTOSAGUARDANDO / 60);
                      var rhours = Math.floor(hours);
                      var minutes = (hours - rhours) * 60;
                      var rminutes = Math.round(minutes);
                      time = rhours + " h " + rminutes + " m";
                    }
                  } else {
                    time = time + ' mins';
                  }

                  return (
                    <tr key={key} className={statusClass}>
                      <td style={{ overflow: 'hidden', whiteSpace: 'nowrap' }} align="left">{status}</td>
                      <td style={{ color: color }} align="left"><b>{data.LEITO}</b></td>
                      <td style={{ overflow: 'hidden', whiteSpace: 'nowrap', color: color }} align="left"><b>{name}</b> ({data.CODIGOATENDIMENTO})</td>
                      <td style={{ overflow: 'hidden', whiteSpace: 'nowrap' }} align="left">{data.DESCRICAOITEM}</td>
                      <td className={tdClassRx} align="left"><span className={spanClassRx}></span>{data.IMAGEMREALIZADA}</td>
                      <td className={tdClassFarm} align="left"><span className={spanClassFarm}></span>{time}</td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
});

export default PdfRadiologia;